module.exports = __webpack_public_path__ + "static/ZaliosiosPolInst-809a93c149130b986eb76cce6042df74.png";